/**
 * Controller: changePasswordToken
 */
angular.module('acme.view.controller.changePasswordToken', [])
.controller('ChangePasswordTokenController', [function() {

    return {

      init: function() {
        return true;
      }

    };

}]);